
/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoRequestSalerSettlement {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * 
     */
    SalerId?: string;
    /**
     * 
     */
    PoolId?: string;
    /**
     * 
     */
    Month?: string;
}

/**
 * -表单校验
 */
export const DtoRequestSalerSettlementRules = {
}
